import React, { Fragment, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ButtonContainer, SubheaderSection, TextField } from "../../components";
import { Formik } from "formik";
import * as Yup from "yup";

import { useNavigate } from "react-router-dom";
import pages from "../../constants/pages";
import { useAxios } from "../../hooks";
import { setUserName } from "../../redux/slices/memberSlice";
import { LoadingButton } from "@mui/lab";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "5.5px",
    background: "rgb(255, 255, 255)",
    [theme.breakpoints.up("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%",
    },
  },
}));

const ContentBox = styled(Box)({
  padding: "20px",
  textAlign: "center",
  alignContent: "center",
  alignItems: "center",
});

const AddEmailIDDialog = ({ addEmailIDPopUp, setAddEmailIDPopUp }) => {
  const axios = useAxios();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const [step, setStep] = useState(true);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    emailID: Yup.string().required("Name is required"),
  });

  return (
    <StyledDialog
      open={addEmailIDPopUp}
      onClose={() => {
        setAddEmailIDPopUp(false);
      }}
      fullWidth
      maxWidth="md"
    >
      <DialogContent style={{ padding: "0px" }}>
        <ContentBox>
          <SubheaderSection
            textAlign="start"
            variant="h6"
            title={`Enter Your Email ID`}
            titleColor="#2b2b2b"
            titleProps={{ fontWeight: 600 }}
          />
          <Grid container>
            <Formik
              initialValues={{ emailID: "", otpNo: "", otpSend: false }}
              validationSchema={validationSchema}
              onSubmit={(formData, { setSubmitting }) => {
                setLoading(true);
                axios({
                  url:
                    "/notification/otp/verify-otp?type=email&visitor_id=" +
                    visitorData.ID,
                  method: "POST",
                  data: { otp: formData.otpNo, contact: formData.emailID },
                  customAuthToken: sessionStorage.getItem("authToken"),
                })
                  .then((response) => {
                    if (response.status) {
                      setAddEmailIDPopUp(false);
                      setStep(true);
                    }
                    setLoading(false);
                  })
                  .catch(() => {
                    setLoading(false);
                  });
              }}
            >
              {(formikProps) => {
                function handleSendOtp(emailID) {
                  setLoading(true);

                  axios({
                    url: "/notification/otp/send-otp?type=email",
                    data: {
                      name: visitorData.firstName + visitorData.lastName,
                      contact: emailID,
                    },
                    method: "POST",
                    customAuthToken: sessionStorage.getItem("authToken"),
                  })
                    .then((response) => {
                      if (response.status) {
                        formikProps.setFieldValue("otpSend", true);
                      }
                      setLoading(false);
                    })
                    .catch((error) => {
                      setLoading(false);
                    });
                }

                return (
                  <Fragment>
                    <Grid item container spacing={2}>
                      <Grid item xs={9}>
                        <TextField
                          name="emailID"
                          size="small"
                          placeholder="Enter Your Email Id"
                          formikProps={formikProps}
                          disabled={formikProps.values.otpSend}
                        ></TextField>
                      </Grid>
                      <Grid item xs={3} sx={{ alignContent: "center" }}>
                        <LoadingButton
                          size="small"
                          variant="outlined"
                          onClick={() => {
                            !formikProps.values.otpSend
                              ? handleSendOtp(formikProps?.values?.emailID)
                              : formikProps.setFieldValue("otpSend", false);
                          }}
                          loading={loading}
                        >
                          {`${!formikProps.values.otpSend ? "Verify" : "Edit"}`}
                        </LoadingButton>
                      </Grid>
                    </Grid>

                    {formikProps.values.otpSend && (
                      <Grid item container mt={2}>
                        <TextField
                          name="otpNo"
                          size="small"
                          placeholder="Enter Your OTP"
                          formikProps={formikProps}
                        ></TextField>
                      </Grid>
                    )}

                    {formikProps.values.otpSend && (
                      <Grid item container justifyContent={"end"} mt={2}>
                        <LoadingButton
                          fullWidth
                          size="small"
                          loading={loading}
                          variant="contained"
                          sx={{ height: "70%", background: "#3936ef" }}
                          onClick={formikProps.handleSubmit}
                          disabled={!formikProps.dirty || !formikProps.isValid}
                        >
                          Submit
                        </LoadingButton>
                      </Grid>
                    )}
                  </Fragment>
                );
              }}
            </Formik>
            <Grid></Grid>
          </Grid>
        </ContentBox>
      </DialogContent>
    </StyledDialog>
  );
};

export default AddEmailIDDialog;
